<template>
  <div>
    <my-header></my-header>
    <applications-proceduring v-if="type === 'proceduring'" ref="applicationsProceduring"></applications-proceduring>
    <applications-competition v-if="type === 'competition'" ref="applicationsCompetition"></applications-competition>
    <my-footer></my-footer>
  </div>
</template>

<script>
import applicationsProceduring from './applications/proceduring'
import applicationsCompetition from './applications/competition'
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
import { bus } from '@/router/index'
export default {
  name: 'applications',
  components: {
    myHeader: myHeader,
    myFooter: myFooter,
    applicationsProceduring: applicationsProceduring,
    applicationsCompetition: applicationsCompetition
  },
  data () {
    return {
      type: 'proceduring'
    }
  },
  created () {
    console.log(this.type, '===')
    bus.$on('applicationsPage', () => {
      this.type = localStorage.getItem('applications') || 'proceduring'
      console.log(this.type, '------------')
    })
    bus.$on('applicationsScroll', val => {
      let child = 'applicationsProceduring'
      if (this.type === 'competition') {
        child = 'applicationsCompetition'
      }
      this.$refs[child].$emit('pageScroll', val)
    })
  },
  beforeDestroy () {
    bus.$off('applicationsPage')
    bus.$off('applicationsScroll')
  },
  mounted () {
    this.type = localStorage.getItem('applications') || 'proceduring'
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
</style>



// WEBPACK FOOTER //
// src/components/applications.vue